/**
 * ThemeToggle.jsx
 * -----------------------------------------------------------------------------
 * Botón de alternancia claro/oscuro. Pensado para vivir dentro del AppBar de
 * Syncfusion (usa la clase utilitaria `xflow-theme-toggle` definida en
 * _dark-mode.scss). Funciona igual en escritorio y móvil.
 */
import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "./ThemeProvider";

export default function ThemeToggle({ className = "" }) {
  const { isDark, toggleTheme } = useTheme();
  const label = isDark ? "Activar modo claro" : "Activar modo oscuro";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={`xflow-theme-toggle ${className}`.trim()}
      title={label}
      aria-label={label}
      aria-pressed={isDark}
    >
      {isDark ? <Sun size={20} strokeWidth={2.1} /> : <Moon size={20} strokeWidth={2.1} />}
    </button>
  );
}
